import { GET_CURRENT_USER, SET_CURRENT_USER, GET_LIST_PACKAGE, GET_TURN_REMAIN, LOGIN_OTP, LOGIN_PASSWORD, LOGOUT_USER, SET_PU4_NEVER_SHOW, UPDATE_PASSWORD } from './contants'

const initState = {
	userInfo: null,
	token: null,
	remainTurn: [],
	listPackage: []
}
const reducerAccount = (state = initState, actions) => {
	switch (actions.type) {
		case GET_CURRENT_USER:
			return {
				...state,
				userInfo: actions.payload.data
			}
		case SET_CURRENT_USER:
			return {
				...state,
				userInfo: actions.data
			}
		case GET_TURN_REMAIN:
			return {
				...state,
				remainTurn: actions.payload.data
			}
		case LOGIN_PASSWORD:
			return {
				...state,
				token: actions.payload.data.token.accessToken
			}
		case LOGIN_OTP:
			return {
				...state,
				token: actions.payload.data.token.accessToken
			}
		case LOGOUT_USER:
			return {
				...state,
				token: null,
				userInfo: null,
				remainTurn: [],
			}
		case GET_LIST_PACKAGE:
			return {
				...state,
				listPackage: actions.payload.data
			}
		case UPDATE_PASSWORD:
			return {
				...state,
				// userInfo: actions?.payload?.data //tạm thời khóa lại vì data khi trả về đang null
			}
		case SET_PU4_NEVER_SHOW:
			return {
				...state,
				userInfo: state.userInfo ? { ...state.userInfo, is_intro_dismissed: 1 } : state.userInfo
			}
		default:
			return state
	}
}
export default reducerAccount
